// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3KGb8","button":"styles_button__wexPD","disabled":"styles_disabled__1PLvd"};